export enum AmbientSoundId {
    STREAM = "stream",
    WIND = "wind",
}
